import component from "./GeoRestrictions";
import initializeSvelteApp from "common/initializeSvelteApp";

window.initializeGeoRestrictions = (
  target = ".js-geo-restrictions",
  immediate = false
) => {
  initializeSvelteApp({
    component,
    target,
    props: element => {
      return {
        territories: JSON.parse(element.getAttribute("data-territories")),
      };
    },
    immediate,
  });
};

window.initializeGeoRestrictions();
